import React, { useState } from 'react';
import { Button } from '@mui/material';
import { CheckTwoTone } from '@mui/icons-material';
import { TemporaryHousingCompleteDialog } from './TemporaryHousingCompleteDialog';

const TemporaryHousingDoneButton = (props) => {
  const [open, setOpen] = useState(false);

  const handleClose = (doneDate, isSubmit) => {
    if (isSubmit) props.onClick(doneDate);

    setOpen(false);
  };

  const openDialog = () => setOpen(true);

  return (
    <>
      <Button
        variant="contained"
        color="success"
        startIcon={<CheckTwoTone />}
        onClick={openDialog}
      >
        Done
      </Button>
      {open && (
        <TemporaryHousingCompleteDialog open={open} onClose={handleClose} Contact={props.Contact}/>
      )}
    </>
  );
};

export { TemporaryHousingDoneButton };
